import {
  addDuration,
  createDate,
  cloneDate,
  createDuration,
  setMidnight,
} from "./date";
import { serviceColors } from "./options";

export function times(slotMinTime, slotMaxTime, slotDuration) {
  let times = [];
  let date = setMidnight(createDate("2020-01-01"));
  let end = setMidnight(cloneDate(date));

  let min = createDuration(slotMinTime);
  let max = createDuration(slotMaxTime);

  addDuration(date, min);
  addDuration(end, max);

  while (date < end) {
    let formatedDate;
    if (date.getMinutes() === 0) {
      formatedDate = Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        timeZone: "UTC",
      }).format(date);
    } else {
      formatedDate = Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
        timeZone: "UTC",
      })
        .format(date)
        .split(" ")[0];
    }
    times.push(formatedDate);
    addDuration(date, createDuration(slotDuration));
  }
  return times;
}

export function getTitleColor(service) {
  if (service !== undefined) {
    return serviceColors[service.id];
  }
  return "";
}

export function calculateJobCounts(response) {
  let jobCounts = {};
  Object.entries(response.data).forEach(([key, event]) => {
    event.services.forEach((el) => {
      if (jobCounts.hasOwnProperty(el.id)) {
        jobCounts[el.id] += 1;
      } else {
        jobCounts[el.id] = 1;
      }
    });
  });
  return jobCounts;
}

export function calculateTopMargin(date, event, eventIndex, slotHeight = 50) {
  // start is a timestamp as setHours returns timestamp
  let start = date;
  start.setUTCHours(8, 0, 0);
  let diff = event.datetime.getTime() - start;
  let slots = diff / 1000 / 60 / 15;
  let offset = Math.round(slots);
  return offset * slotHeight + eventIndex * 25 + 50;
}

export function scheduleEvents(events, columnIds) {
  const calendar = {};
  const overflowColumn = "Overflow";

  // Initialize calendar structure with provided column IDs
  columnIds.forEach((colId) => {
    calendar[colId] = {};
  });
  calendar[overflowColumn] = {};

  events.forEach((event) => {
    const eventTime = event.datetime;
    let placed = false;

    for (const colId of columnIds) {
      if (!calendar[colId][eventTime]) {
        calendar[colId][eventTime] = [];
      }

      if (calendar[colId][eventTime].length === 0) {
        calendar[colId][eventTime].push(event);
        placed = true;
        break;
      }
    }

    if (!placed) {
      if (!calendar[overflowColumn][eventTime]) {
        calendar[overflowColumn][eventTime] = [];
      }
      calendar[overflowColumn][eventTime].push(event);
    }
  });

  return calendar;
}

export function distributeOnDateTime(events) {
  const distributedEvents = {};
  events.forEach((event) => {
    const eventTime = event.datetime;
    if (!distributedEvents[eventTime]) {
      distributedEvents[eventTime] = [];
    }
    distributedEvents[eventTime].push(event);
  });
  return distributedEvents;
}
